import { useContext, useMemo } from 'react';
import { selectLocale } from 'models/localization';
import { useSelector } from 'react-redux';
import { UserSessionContext } from 'components/UserSession';
import findAvailableLocale from 'models/helpers/findAvailableLocale';

const encodeQueryData = (data: Record<string, string>) => Object.keys(data).map((key) => [key, data[key]].map(encodeURIComponent).join('=')).join('&');

const mapLocale = (locale: string) => {
  switch (locale) {
    case 'zh-Hant': return 'zh-cht.';
    case 'id-ID': return 'id.';
    case 'ja': return 'ja.';
    case 'ko': return 'ko.';
    case 'th': return 'th.';
    default: return '';
  }
};

const useEventBrandingUrl = (hashState: string) => {
  const locale = useSelector(selectLocale);
  const { userSession } = useContext(UserSessionContext);
  const {
    organizerName,
    organizerDomain,
    name,
  } = useSelector((state) => state.eventConfigs);

  const englishEventName = useMemo(() => (typeof name === 'string' ? name : findAvailableLocale(name, 'en')) ?? 'nil', [name]);
  const clientName = userSession?.fullName ?? 'nil';
  const email = userSession?.email ?? 'nil';

  const queryData = useMemo(() => ({
    organiser: organizerName ?? 'nil',
    domain: organizerDomain ?? 'nil',
    utm_source: clientName,
    utm_medium: englishEventName,
    utm_campaign: 'sticky-brand-badge',
    utm_content: email,
  }), [clientName, email, englishEventName, organizerDomain, organizerName]);

  const brandingUrl = `https://${mapLocale(locale)}eventx.io/products/virtual-exhibition-v/?${encodeQueryData(queryData)}#${hashState || ''}`;
  return useMemo(() => brandingUrl, [brandingUrl]);
};

export default useEventBrandingUrl;
